module.exports = [{"key":"lekki","value":"Lekki"},{"key":"victoria_island","value":"Victoria Island"},{"key":"ikoyi","value":"ikoyi"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/fixed-rate-location.json
// module id = 2210
// module chunks = 1